import type { Step } from '@/components/wizard/Step';

import type { SetupOwnCloudState } from './SetupOwnCloudState';
import { ConnectRestoreAccount } from './connectRestoreAccount';

export const SetupOwnCloudRestoreFlow: Step<SetupOwnCloudState> = {
  name: 'Connect Azure restore account',
  Component: ConnectRestoreAccount,
  nonReturnable: false,
};
